import { gql } from '@apollo/client';

export const UPDATE_CUSTOMER_SNAPSHOT = gql`
  mutation Flex_UpdateCustomerSnapshot(
    $utilityAccountId: Int!
    $input: UpdateCustomerSnapshotInput!
  ) {
    updateCustomerSnapshot(utilityAccountId: $utilityAccountId, input: $input) {
      success
    }
  }
`;
